// Search
export const TICKET_CALENDAR_SEARCH_START_LOADING = "TICKET_CALENDAR_SEARCH_START_LOADING";
export const TICKET_CALENDAR_SEARCH_END_LOADING = "TICKET_CALENDAR_SEARCH_END_LOADING";
export const TICKET_CALENDAR_SEARCH_LOADED = "TICKET_CALENDAR_SEARCH_LOADED";
export const SET_TICKET_CALENDAR_FILTER = "SET_TICKET_CALENDAR_FILTER";
